import { __assign, __rest } from "tslib";
import * as React from 'react';
import clsx from 'clsx';
import { makeStyles, createStyles } from '../../styles';
import { ListSubheader } from '../../ListSubheader';
export var useStyles = makeStyles(function (theme) {
    return createStyles({
        root: {
            minHeight: '22px',
            padding: '2px 12px',
            fontSize: theme.typography.fontSizeSmall,
            fontWeight: theme.typography.fontWeightSemiBold,
            backgroundColor: theme.palette.background.b4,
            borderTop: "1px solid ".concat(theme.palette.border.main),
            borderBottom: "1px solid ".concat(theme.palette.border.main),
        },
        list: {
            margin: 0,
            padding: 0,
            '& > li:hover': {
                textDecoration: 'underline',
            },
        },
    });
});
export var MenuListSubheader = function (props) {
    var className = props.className, other = __rest(props, ["className"]);
    var classes = useStyles(props);
    return (React.createElement(ListSubheader, __assign({ className: clsx(classes.root, className) }, other, { tabIndex: undefined })));
};
export default MenuListSubheader;
//# sourceMappingURL=Combobox.MenuListSubheader.js.map